// Form validation utilities
export const validators = {
  required: (value) => {
    if (!value || (typeof value === 'string' && !value.trim())) {
      return 'This field is required';
    }
    return null;
  },

  email: (value) => {
    if (!value) return null;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return 'Please enter a valid email address';
    }
    return null;
  },

  minLength: (min) => (value) => {
    if (!value) return null;
    if (value.length < min) {
      return `Must be at least ${min} characters`;
    }
    return null;
  },

  maxLength: (max) => (value) => {
    if (!value) return null;
    if (value.length > max) {
      return `Must be no more than ${max} characters`;
    }
    return null;
  },

  url: (value) => {
    if (!value) return null;
    try {
      new URL(value);
      return null;
    } catch {
      return 'Please enter a valid URL';
    }
  },

  phone: (value) => {
    if (!value) return null;
    const phoneRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
    if (!phoneRegex.test(value)) {
      return 'Please enter a valid phone number';
    }
    return null;
  },

  number: (value) => {
    if (!value) return null;
    if (isNaN(Number(value))) {
      return 'Please enter a valid number';
    }
    return null;
  },

  min: (minVal) => (value) => {
    if (!value) return null;
    if (Number(value) < minVal) {
      return `Value must be at least ${minVal}`;
    }
    return null;
  },

  max: (maxVal) => (value) => {
    if (!value) return null;
    if (Number(value) > maxVal) {
      return `Value must be no more than ${maxVal}`;
    }
    return null;
  }
};

// Validate a single field with multiple validators
export const validateField = (value, fieldValidators = []) => {
  for (const validator of fieldValidators) {
    const error = validator(value);
    if (error) return error;
  }
  return null;
};

// Validate entire form
export const validateForm = (values, validationRules) => {
  const errors = {};
  
  Object.keys(validationRules).forEach((field) => {
    const error = validateField(values[field], validationRules[field]);
    if (error) {
      errors[field] = error;
    }
  });
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};
